import { Controller } from "@hotwired/stimulus";

class HeaderController extends Controller {
  static targets = ["subMenu", "headerDrawer"];

  #activeLinkTitle = undefined;

  connect() {
    //document.addEventListener("scroll", this.toggleShadow);

    this._onSubMenuClick = this.#handleSubMenuClick.bind(this);
    this.element.addEventListener("click", this._onSubMenuClick);
  }

  disconnect() {
    this.element.removeEventListener("click", this._onSubMenuClick);
  }

  toggleShadow = () => {
    const shadowClass = "tw:md:shadow-[0_5px_10px_0_rgba(0,0,0,.08)]";

    if (window.scrollY > 0) {
      return document.querySelector("header").classList.add(shadowClass);
    }

    return document.querySelector("header").classList.remove(shadowClass);
  };

  get #activeSubMenuTarget() {
    return this.subMenuTargets.find(
      (subMenu) => subMenu.dataset.linkTitle === this.#activeLinkTitle,
    );
  }

  showSubMenu(event) {
    const title = event.target.dataset.linkTitle;

    if (this.#activeLinkTitle !== title) {
      this.hideSubMenu();

      // apertura immediata; capture solo dopo dwell (filtra le carrellate)
      clearTimeout(this._hoverTimer);
      const hasDropdown = this.subMenuTargets.some(
        (s) => s.dataset.linkTitle === title,
      );
      this._hoverTimer = setTimeout(() => {
        if (window.posthog) {
          window.posthog.capture("menu_item_hover", {
            menu_label: title,
            has_dropdown: hasDropdown,
            device_type: "desktop",
          });
        }
      }, 450);
    }

    this.#activeLinkTitle = title;
    this.#activeSubMenuTarget?.classList.remove("tw:hidden");
  }

  hideSubMenu() {
    clearTimeout(this._hoverTimer);
    this.#activeSubMenuTarget?.classList.add("tw:hidden");
  }

  #handleSubMenuClick(event) {
    const link = event.target.closest("[data-header-target='subMenu'] a[href]");
    if (!link) return;

    const dropdown = link.closest("[data-header-target='subMenu']");

    if (window.posthog) {
      window.posthog.capture("menu_dropdown_link_click", {
        link_label: link.textContent.trim(),
        link_url: link.getAttribute("href"),
        parent_menu: dropdown?.dataset.linkTitle || null,
        device_type: "desktop",
      });
    }
  }
}

Stimulus.register("header", HeaderController);